var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data),function(item,key){return _c('info-radio',{key:key,attrs:{"filter-id":_vm.filterId,"current-value":_vm.currentValue,"name":_vm.name,"value":item.value,"child-filter":item.childFilter}},[_c('p',[_vm._v("\n            "+_vm._s(_vm.$t(item.value))+"\n        ")])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad1777fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/RadiosFilter.vue
// module id = null
// module chunks = 